var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({attrs:{"value":_vm.value},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"change":_vm.onChange,"input":_vm.onInput,"clear":_vm.onClear}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }